(function () {
  'use strict';

  function setStatus(scope, message) {
    var status = scope && scope.querySelector('[data-ks-upsell-status]');
    if (status) status.textContent = message;
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.CartCount, #CartCountCavas').forEach(function (node) {
      node.textContent = cart.item_count;
    });

    var headerTotal = document.getElementById('header-cart-total');
    if (
      headerTotal &&
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.theme &&
      window.theme.moneyFormat
    ) {
      headerTotal.innerHTML = window.Shopify.formatMoney(cart.total_price, window.theme.moneyFormat);
    }
  }

  function fetchHtml(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart view could not be refreshed.');
      return response.text();
    });
  }

  function refreshDrawer() {
    var cartInfo = document.getElementById('cart-info');
    if (!cartInfo) return Promise.resolve();

    return fetchHtml('/cart?view=json').then(function (html) {
      cartInfo.innerHTML = html;
    });
  }

  function refreshPopup() {
    var popup = document.getElementById('content_cart__popup_nt');
    if (!popup) return Promise.resolve(false);

    return fetchHtml('/cart?view=upsell').then(function (html) {
      popup.innerHTML = html;
      return true;
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('desktop_cart');
    var overlay = document.querySelector('.sidebar-overlay');
    if (drawer) drawer.classList.add('active', 'item_count');
    if (overlay) overlay.classList.add('act');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ks-upsell-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = Number(button.getAttribute('data-variant-id'));
    var wrapper = button.closest('.ks-upsells');
    var label = button.querySelector('span') || button;
    var defaultLabel = button.getAttribute('data-default-label') || 'Přidat';

    if (!variantId) {
      setStatus(wrapper, 'Produkt se nepodařilo identifikovat. Otevřete prosím jeho detail.');
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Přidávám…';
    setStatus(wrapper, 'Přidávám produkt do košíku.');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (data) {
          throw new Error(data.description || 'Produkt se nepodařilo přidat.');
        });
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Košík se nepodařilo načíst.');
          return response.json();
        });
      })
      .then(function (cart) {
        updateCartCount(cart);
        button.removeAttribute('aria-busy');
        button.classList.add('is-added');
        label.textContent = 'Přidáno ✓';
        setStatus(wrapper, 'Produkt byl přidán do košíku.');

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }

        return Promise.all([refreshPopup(), refreshDrawer()]).then(function (results) {
          if (wrapper && wrapper.classList.contains('ks-upsells--product')) {
            openDrawer();
          } else if (!results[0] && !(wrapper && wrapper.classList.contains('ks-upsells--drawer'))) {
            openDrawer();
          }
        });
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = defaultLabel;
        setStatus(wrapper, 'Produkt se nepodařilo přidat. Zkuste to prosím znovu.');
      });
  });
})();
